import _includes from 'lodash/includes'
import {getGeneralSiteInfo, getUserPreferences} from '.'

export default class GMC {
    static init() {
        const {countryCode, siteConsent} = getGeneralSiteInfo()
        GMC.countryCode = countryCode
        GMC.siteConsent = siteConsent
    }

    static setupDomElements(sourceContainerID) {
        GMC.wrapperEl = document.getElementById(sourceContainerID)

        GMC.consentChk = GMC.wrapperEl.querySelector('.gigya-custom-checkbox .gigya-input-checkbox')

        GMC.braunCheckbox = GMC.wrapperEl.querySelector(
            '.gigya-braun-checkbox .gigya-input-checkbox',
        )
        GMC.delonghiCheckbox = GMC.wrapperEl.querySelector(
            '.gigya-delonghi-checkbox .gigya-input-checkbox',
        )
        GMC.kenwoodCheckbox = GMC.wrapperEl.querySelector(
            '.gigya-kenwood-checkbox .gigya-input-checkbox',
        )
        GMC.nutribulletCheckbox = GMC.wrapperEl.querySelector(
            '.gigya-nutribullet-checkbox .gigya-input-checkbox',
        )
        GMC.braunCheckboxSms = GMC.wrapperEl.querySelector(
            '.gigya-braun-checkbox-sms .gigya-input-checkbox',
        )
        GMC.delonghiCheckboxSms = GMC.wrapperEl.querySelector(
            '.gigya-delonghi-checkbox-sms .gigya-input-checkbox',
        )
        GMC.kenwoodCheckboxSms = GMC.wrapperEl.querySelector(
            '.gigya-kenwood-checkbox-sms .gigya-input-checkbox',
        )
        GMC.nutribulletCheckboxSms = GMC.wrapperEl.querySelector(
            '.gigya-nutribullet-checkbox-sms .gigya-input-checkbox',
        )
        GMC.checkboxes = [
            GMC.braunCheckbox,
            GMC.delonghiCheckbox,
            GMC.kenwoodCheckbox,
            GMC.nutribulletCheckbox,
            GMC.braunCheckboxSms,
            GMC.delonghiCheckboxSms,
            GMC.kenwoodCheckboxSms,
            GMC.nutribulletCheckboxSms,
        ]
        GMC.wrapperSubscription = GMC.wrapperEl.querySelector('.subscribe-wrapper')
        GMC.removeSubscriptionEls = GMC.wrapperEl.querySelectorAll('.js-gigya__removing-sub')
    }

    static updateUI({preferences}) {
        GMC.userPreference = preferences[GMC.siteConsent]

        GMC.userPreferenceConsentGranted = preferences[GMC.siteConsent]?.isConsentGranted ?? false
        GMC.userEntitlements = preferences[GMC.siteConsent]?.entitlements ?? []

        if (GMC.userPreference && GMC.userPreference?.isConsentGranted === true) {
            GMC.consentChk.checked = true
            const cleanCountryCode = GMC.countryCode
                ? GMC.countryCode.split(/[_-]/).pop()
                : GMC.countryCode

            GMC.braunCheckbox.checked = _includes(GMC.userEntitlements, `braun${cleanCountryCode}`)
            GMC.delonghiCheckbox.checked = _includes(
                GMC.userEntitlements,
                `delonghi${cleanCountryCode}`,
            )
            GMC.kenwoodCheckbox.checked = _includes(
                GMC.userEntitlements,
                `kenwood${cleanCountryCode}`,
            )
            GMC.nutribulletCheckbox.checked = _includes(
                GMC.userEntitlements,
                `nutribullet${cleanCountryCode}`,
            )
        }
    }

    static updateUiAfterSubmit() {
        const callback = (event) => {
            GMC.updateUI(event)
            GMC.toggleCheckbox()
        }
        getUserPreferences(callback)
    }

    static onAfterScreenLoad = (event) => {
        //GigyaController.onAfterScreenLoad(event)
        const {sourceContainerID} = event
        GMC.setupDomElements(sourceContainerID)
        GMC.updateUI(event)

        // listening for abort sub event
        //DLG.EVE.on(EVENTS.GIGYA.MARKETING.ABORT_SUB, () => GMC.consentChk.click())

        // add event listener to consent checkbox
        GMC.consentChk.addEventListener('click', GMC.toggleCheckbox)

        // run toggleCheckbox for first load
        GMC.toggleCheckbox()

        const lang = window.gigya.thisScript.lang.originalLang
        const countryCode = window.gigya.thisScript.globalConf.countryCodeMapping[lang]
        const countryPrefix = window.gigya.thisScript.globalConf.phonePrefixMapping[countryCode]

        if (!countryPrefix) {
            GMC.hideSMSCheckoboxes()
        }

        // Check if user has phone number
        const hasPhoneNumber = event?.data?.phones?.mobile

        if (!hasPhoneNumber) {
            GMC.hideSMSCheckoboxes()
        }
    }

    static hideSMSCheckoboxes = () => {
        GMC.wrapperEl.querySelector('.gigya-braun-checkbox-sms').classList.add('is-hidden')
        GMC.wrapperEl.querySelector('.gigya-delonghi-checkbox-sms').classList.add('is-hidden')
        GMC.wrapperEl.querySelector('.gigya-kenwood-checkbox-sms').classList.add('is-hidden')
        GMC.wrapperEl.querySelector('.gigya-nutribullet-checkbox-sms').classList.add('is-hidden')
    }

    static toggleCheckbox = (evt) => {
        const consentChkEmpty = evt && !GMC.consentChk.checked && GMC.userPreferenceConsentGranted

        Array.from(GMC.checkboxes).forEach((el) => {
            el.disabled = !GMC.consentChk.checked
        })
        Array.from(GMC.removeSubscriptionEls).forEach((el) => {
            el.classList.toggle('is-hidden', !consentChkEmpty)
        })
        GMC.wrapperSubscription.style.opacity = !GMC.consentChk.checked ? 0.5 : 1
        GMC.wrapperSubscription.querySelector('.dln-btn--update input[type="submit"]').disabled =
            !GMC.consentChk.checked
    }
}
